import { render, staticRenderFns } from "./ViewFlatModal.vue?vue&type=template&id=49847d62&"
import script from "./ViewFlatModal.vue?vue&type=script&lang=js&"
export * from "./ViewFlatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports